import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the dimensionByTeam state domain
 */

const selectDimensionByTeamDomain = (state) =>
  state.get("dimensionByTeam", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoading = () =>
  createSelector(selectDimensionByTeamDomain, (state) => state.get("isLoading"))

export const makeSelectDivisions = () =>
  createSelector(selectDimensionByTeamDomain, (state) => state.get("divisions"))

export const makeSelectDimensions = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("questionList")
  )

export const makeSelectMetricTotal = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("metricTotal")
  )

export const makeSelectTeam = () =>
  createSelector(selectDimensionByTeamDomain, (state) => state.get("team"))

export const makeSelectShowHistory = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("showHistory")
  )

export const makeSelectShowVariation = () => 
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("showVariation")
  )


export const makeSelectIfFirst = () => 
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("ifFirst")
  )

export const makeSelectSwitchMoreDimensions = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("switchMoreDimensions")
  )

export const makeSelectGraphicBars = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("graphicBars")
  )

export const makeSelectIsLoadingGraphicBars = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("isLoadingGraphicBars")
  )

export const makeSelectGraphicTeamPeakon = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("graphicPeakonTeam")
  )

export const makeSelectIsLoadingGraphicTeamPeakon = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("isLoadingGraphicPeakonTeam")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectEvolutionData = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("evolutionData")
  )
export const makeSelectEvolutionLines = () =>
  createSelector(selectDimensionByTeamDomain, (state) =>
    state.get("evolutionLines")
  )

/**
 * Default selector used by DimensionByTeam
 */

const makeSelectDimensionByTeam = () =>
  createSelector(selectDimensionByTeamDomain, (substate) => substate.toJS())

export default makeSelectDimensionByTeam
export { selectDimensionByTeamDomain }
